export type DefaultDeclineTypeT = "Tangent" | "Nominal" | "Secant";

export interface DefaultDeclineType {
  id?: string;
  decline: DefaultDeclineTypeT;
}

export const DEFAULT_DECLINE = "Tangent";
